import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DateRangePickerProps } from '../interface/interface';

const DateRangePicker = ({ onDateChange }: DateRangePickerProps) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    onDateChange(start, end);
  };

  useEffect(() => {
    if (localStorage.getItem('fromDate')) {
      setStartDate(new Date(localStorage.getItem('fromDate') as string));
    }
    if (localStorage.getItem('toDate')) {
      setEndDate(new Date(localStorage.getItem('toDate') as string));
    }

    if (!localStorage.getItem('fromDate')) {
      setStartDate(null);
    }

    if (!localStorage.getItem('toDate')) {
      setEndDate(null);
    }
  }, [localStorage.getItem('fromDate'), localStorage.getItem('toDate')]);

  return (
    <div className="w-full">
      <DatePicker
        selected={startDate}
        onChange={handleDateChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        dateFormat="dd/MM/yyyy"
        placeholderText="Date range"
        className="w-[250px] px-4 py-2 border border-primary-blue-500 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
      />
    </div>
  );
};

export default DateRangePicker;
